export default "__VITE_ASSET__Bs4q5T0e__"